/* tslint:disable */
/* eslint-disable */
export enum VpnTopologyMode {
  Net30 = 'NET30',
  P2P = 'P2P',
  Subnet = 'SUBNET'
}
